import IBC from "assets/images/game/sports/sport - IBC.png";
import GxWicket from "assets/images/game/sports/sport-gx-wicket.png";
import SBO from "assets/images/game/sports/sport-sbo.png";
import { SubGameType } from "types/game";

export const listGameSports: SubGameType[] = [
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "SBO",
    type: "SB",
    featured: "NO",
    new_arrive: "NO",
    picture: SBO
  },
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "BF",
    type: "SB",
    featured: "NO",
    new_arrive: "NO",
    picture: GxWicket
  },
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "IBC",
    type: "SB",
    featured: "NO",
    new_arrive: "NO",
    picture: IBC
  }
];
